export default __webpack_public_path__ + "static/media/1056.6328280e.png";